import React, { useMemo } from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { fs, s, v } from '../../utils/libs';
import { GTFonts, LatoFonts, PoppinsFonts, useTheme } from '../../theme';
const isWeb = Platform.OS === 'web';
type Props = {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: string;
  onPress?: () => void;
  disabled?: boolean;
};

const ReportCard: React.FC<Props> = ({
  title,
  subtitle,
  icon,
  color,
  onPress,
  disabled,
}) => {
  const { theme } = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  return (
    <Pressable
      onPress={disabled ? undefined : onPress}
      disabled={disabled}
      style={({ pressed, hovered }: any) => [
        styles.card,
        disabled && { opacity: 0.5 },
        isWeb && hovered && !disabled && styles.cardHovered,
        pressed && !disabled && { opacity: 0.85 },
      ]}>
      <View style={styles.headerRow}>
        <View style={[styles.iconWrap, !!color && { backgroundColor: color }]}>
          {icon}
        </View>
        <Text numberOfLines={2} style={styles.title}>
          {title}
        </Text>
      </View>
      {!!subtitle && (
        <Text numberOfLines={3} style={styles.subtitle}>
          {subtitle}
        </Text>
      )}
    </Pressable>
  );
};

export default ReportCard;

const createStyles = (theme: any) =>
  StyleSheet.create({
    card: {
      backgroundColor: 'rgba(0,0,0,0.03)',
      borderRadius: theme.borderRadius.md,
      padding: s(14),
      width: '49%',
      marginBottom: v(12),
      ...(isWeb
        ? {
            minHeight: v(130),
            cursor: 'pointer',
            transition: 'all 0.2s ease-out',
          }
        : {}),
      borderWidth: 1,
      borderColor: theme.colors.border,
    },
    cardHovered: {
      backgroundColor: theme.colors.surfaceSecondary,
      transform: [{ translateY: -2 }],
    },
    iconWrap: {
      width: s(isWeb ? 45 : 36),
      height: s(isWeb ? 45 : 36),
      borderRadius: s(8),
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.colors.primary,
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: v(10),
      gap: s(6),
    },
    title: {
      fontFamily: GTFonts.semibold,
      fontSize: fs(14),
      lineHeight: fs(18),
      color: theme.colors.text,
      flexShrink: 1,
      overflow: 'hidden',
    },
    subtitle: {
      fontFamily: GTFonts.regular,
      fontSize: fs(12),
      marginTop: v(3),
      color: theme.colors.textSecondary,
    },
  });
